var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',[_c('v-progress-circular',{attrs:{"size":90,"width":15,"color":"purple","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }